import { SET_ACTIVE_MENU_ITEM } from './../actions/menu';

const activeMenuItem = (state = [], action) => {
  switch (action.type) {
    case SET_ACTIVE_MENU_ITEM:
      return action.id;
    default:
      return state;
  }
};

export { activeMenuItem as default };



// WEBPACK FOOTER //
// ./src/reducers/activeMenuItem.js